import { useState } from 'react';
import { useEffect } from 'react';
import { logEvent } from "../utils/analytics";
import { useLocation } from 'react-router-dom';
import { BiMinus, BiPlus } from 'react-icons/bi';

const allFaqs = [
    {
        id: 1,
        aliasId: 'why-should-i-vote',
        question: "WHEN IS THE NEXT ELECTION IN LAGOS?",
        answer: "The next election in Lagos State is the Local Government Election scheduled for July 12, 2025.  It is run by the Lagos State Independent Electoral Commission (LASIEC) not INEC. Visit the LASIEC site for any information you don't find here.",
        isOpen: false
    },
    {
        id: 2,
        question: "HOW DO I REGISTER TO VOTE IN THE JULY 12 LAGOS LGA ELECTIONS?",
        answer: "Great news! If you already have a valid voters card that you used to vote in the 2023 Presidential or Gubernatorial elections, you will use that same voters card in this election. However, If you do not have a valid voter's card already, you will not be able to vote in this election as INEC is not conducting any voter registration exercises in Lagos State at this time.",
        isOpen: false
    },
    {
        id: 3,
        question: "WHERE WILL I GO TO VOTE?",
        answer: "Your voting location (polling unit) is determined by your address during registration. You can find your polling unit by checking your Permanent Voter's Card (PVC) or using INEC's online polling unit locator. You must vote at your designated polling unit - you cannot vote at any other location.",
        isOpen: false
    },
    {
        id: 4,
        question: "WHAT DOCUMENTS DO I NEED TO VOTE?",
        answer: "You need your Permanent Voter's Card (PVC) to vote. This is the only document required on election day. If you've registered but haven't collected your PVC, you cannot vote. Make sure to collect your PVC from your INEC office before election day.",
        isOpen: false
    },
    {
        id: 5,
        question: "CAN I VOTE IF I'M NOT IN LAGOS ON ELECTION DAY?",
        answer: "No, you must vote at your registered polling unit. Nigeria does not currently have an absentee voting system. If you've moved to a different state or local government area, you'll need to transfer your voter registration to your new location during the voter transfer periods.",
        isOpen: false
    },
    {
        id: 6,
        question: "WHO ARE THE CANDIDATES RUNNING IN THIS ELECTION?",
        answer: "In the July 12, 2025 Lagos State LGA election, you will be able to vote for your local government chairman and your local government councillor. To find out who is running for those seats in your area, enter your address in the address field at https://helpmevote.ng",
        isOpen: false
    },
    {
        id: 7,
        question: "HOW CAN I VERIFY MY VOTER REGISTRATION STATUS?",
        answer: <p>You can verify your registration status on INEC's official website (<a className="underline" target="_blank" rel="noreferrer" href="https://cvr.inecnigeria.org/voter_verification/">https://cvr.inecnigeria.org/voter_verification</a>) using their voter verification portal. You'll need your Voter Identification Number (VIN) or other details used during registration.</p>,
        isOpen: false
    },
    {
        id: 8,
        aliasId: 'how-to-vote',
        question: "WHAT IS THE VOTING PROCESS LIKE?",
        answer: "On election day, arrive at your polling unit with your PVC. Join the queue, present your PVC for verification, get accredited by running your thumbprint and live picture through the necessary scanners, receive your ballot paper, mark your choice in secret, and cast your ballot in the ballot box.",
        isOpen: false
    },
    {
        id: 9,
        question: "WHAT IF I LOST MY PVC?",
        answer: "If you lose your Permanent Voter's Card, you can request a replacement at any INEC office. You'll need to bring a valid form of identification and may need to complete an affidavit. There may be a small replacement fee. Apply for replacement well before election day.",
        isOpen: false
    },
    {
        id: 10,
        question: "CAN I CHANGE MY POLLING UNIT?",
        answer: "Yes, you can transfer your voter registration to a new polling unit if you've moved. This must be done during INEC's voter transfer periods. Visit your new local INEC office with your PVC and proof of new address. The transfer process is free but must be completed before election periods.",
        isOpen: false
    }
];

export default function FAQ() {

    const location = useLocation();
    const [selectedId, setSelectedId] = useState(-1);

    useEffect(() => {
        const { hash = '' } = location;
        const targetId = hash.substring(1);

        if (targetId) {
            const findFaq = allFaqs.find(faq => faq.aliasId === targetId);
            findFaq && setSelectedId(findFaq.id)
        }

    }, [location])

    const toggleFAQ = (id) => {
        if (id === selectedId) {
            setSelectedId(-1)
        } else {
            const findFaq = allFaqs.find(faq => faq.id === id);
            logEvent('FAQ', 'Opened faq', findFaq.question)
            setSelectedId(id)
        }
    };


    return (
        <section className="py-16 bg-slate-900 rounded-b-2xl ">
            <div className="container mx-auto px-8">
                <h2 className="text-2xl font-bold mb-6 text-white">Popular Questions</h2>

                <div className="max-w-2xl mx-auto">
                    {allFaqs.map((faq) => (
                        <div id={faq.aliasId || `faq-${faq.id}`} key={faq.id} className="accordion-item border-b border-slate-700 py-3" data-state={selectedId === faq.id ? "open" : "closed"}>
                            <button
                                className="w-full flex justify-between items-end text-left text-gray-300 hover:text-white transition-colors"
                                onClick={() => toggleFAQ(faq.id)}
                            >
                                <h3 className="text font-medium capitalize pr-4 ">{faq.question.toLowerCase()}</h3>
                                {faq.isOpen ? (
                                    <BiMinus className="flex-shrink-0 w-5 h-5" />
                                ) : (
                                    <BiPlus className="flex-shrink-0 w-5 h-5" />
                                )}
                            </button>

                            {selectedId === faq.id && (
                                <div className="mt-4 text-gray-200 whitespace-pre-line leading-relaxed text-sm">
                                    {faq.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
